import { DatePivotParams } from "../../entities/date_pivot_params";
import dayjs from "../../utils/dayjs";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "month",
  measure: "Purchase Order To Place", // Default measure - will be updated dynamically
  segments: ["location"],
  minDate: dayjs.utc().startOf("month").toDate(),
  maxDate: dayjs.utc().add(12, "month").startOf("month").toDate(),
  filters: [],
  postFilters: [],
};
